import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconIntersectionPointsS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 5C3.77614 5 4 4.77614 4 4.5C4 4.22386 3.77614 4 3.5 4C3.22386 4 3 4.22386 3 4.5C3 4.77614 3.22386 5 3.5 5ZM3.5 6C4.32843 6 5 5.32843 5 4.5C5 3.67157 4.32843 3 3.5 3C2.67157 3 2 3.67157 2 4.5C2 5.32843 2.67157 6 3.5 6Z"
        fill="var(--color-typo-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 10C3.77614 10 4 9.77614 4 9.5C4 9.22386 3.77614 9 3.5 9C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10ZM3.5 11C4.32843 11 5 10.3284 5 9.5C5 8.67157 4.32843 8 3.5 8C2.67157 8 2 8.67157 2 9.5C2 10.3284 2.67157 11 3.5 11Z"
        fill="var(--color-typo-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 13C7.77614 13 8 12.7761 8 12.5C8 12.2239 7.77614 12 7.5 12C7.22386 12 7 12.2239 7 12.5C7 12.7761 7.22386 13 7.5 13ZM7.5 14C8.32843 14 9 13.3284 9 12.5C9 11.6716 8.32843 11 7.5 11C6.67157 11 6 11.6716 6 12.5C6 13.3284 6.67157 14 7.5 14Z"
        fill="var(--color-typo-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8ZM7.5 9C8.32843 9 9 8.32843 9 7.5C9 6.67157 8.32843 6 7.5 6C6.67157 6 6 6.67157 6 7.5C6 8.32843 6.67157 9 7.5 9Z"
        fill="var(--color-typo-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 4C10.7761 4 11 3.77614 11 3.5C11 3.22386 10.7761 3 10.5 3C10.2239 3 10 3.22386 10 3.5C10 3.77614 10.2239 4 10.5 4ZM10.5 5C11.3284 5 12 4.32843 12 3.5C12 2.67157 11.3284 2 10.5 2C9.67157 2 9 2.67157 9 3.5C9 4.32843 9.67157 5 10.5 5Z"
        fill="var(--color-typo-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 10C12.7761 10 13 9.77614 13 9.5C13 9.22386 12.7761 9 12.5 9C12.2239 9 12 9.22386 12 9.5C12 9.77614 12.2239 10 12.5 10ZM12.5 11C13.3284 11 14 10.3284 14 9.5C14 8.67157 13.3284 8 12.5 8C11.6716 8 11 8.67157 11 9.5C11 10.3284 11.6716 11 12.5 11Z"
        fill="var(--color-typo-primary)"
      />
    </svg>
  )
}
export const IconIntersectionPoints = createIcon({
  l: IconIntersectionPointsS,
  m: IconIntersectionPointsS,
  s: IconIntersectionPointsS,
  xs: IconIntersectionPointsS,
  name: 'IconIntersectionPoints',
})
